import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import axios from "@/api";
import { getCompany } from "@/publicjs/company";
import { imageInBase64 } from "@/publicjs/logoCompany";
import { money, format } from "@/publicjs/money";
import { formatDateTime } from "@/publicjs/formatDate";
import styles from "@/publicjs/styles";
import { errorActions } from "@/alerts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const printOnA4 = async (idExternalShopping) => {
  try {
    const dataStore = JSON.parse(localStorage.getItem("access"));
    const company = await getCompany(dataStore.user.store);
    const base64Image = await imageInBase64(company.companyLogo);
    const response = await axios.get(
      `imprimir-compras-externas/?id=${idExternalShopping}`,
    );
    const registers = response.data;

    const qrValue =
      registers.orden.qr_url && registers.orden.qr_url.length > 0
        ? registers.orden.qr_url
        : registers.orden.ecf;

    const docDefinition = {
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [24, 140, 24, 24],
      header(currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                width: 100,
                stack: [{ image: base64Image, fit: [80, 80] }],
                alignment: "left",
                margin: [0, 10, 0, 0],
              },
              {
                width: 285,
                stack: [
                  {
                    text: company.companyName,
                    fontSize: styles.fontSize.pdf.xl,
                    alignment: "left",
                    bold: true,
                    color: styles.colors.colorTitle,
                  },
                  {
                    text: "Documento informativo de compra externa",
                    fontSize: styles.fontSize.pdf.md,
                    alignment: "left",
                    color: styles.colors.colorDescription,
                  },
                  {
                    text: "No afecta inventario, lotes ni kardex",
                    fontSize: styles.fontSize.pdf.sm,
                    alignment: "left",
                    color: styles.colors.colorDescription,
                  },
                ],
                alignment: "left",
                margin: [2, 10, 24, 0],
              },
              {
                table: {
                  widths: ["*"],
                  body: [
                    [
                      {
                        stack: [
                          {
                            text: "COMPRA EXTERNA",
                            fontSize: styles.fontSize.pdf.lg,
                            alignment: "center",
                            color: styles.colors.colorTitle,
                            bold: true,
                            margin: [0, 5, 0, 5],
                          },
                          {
                            text: `e-NCF: ${registers.orden.ecf}`,
                            fontSize: styles.fontSize.pdf.md,
                            alignment: "center",
                            color: styles.colors.colorTitle,
                            bold: true,
                            margin: [0, 5, 0, 5],
                          },
                          {
                            text: registers.orden.estado,
                            fontSize: styles.fontSize.pdf.md,
                            alignment: "center",
                            color: styles.colors.colorTitle,
                            margin: [0, 5, 0, 5],
                          },
                        ],
                      },
                    ],
                  ],
                },
                layout: {
                  hLineWidth(i, node) {
                    if (i === 0 || i === node.table.body.length) {
                      return 2;
                    }
                    return 0;
                  },
                  hLineColor() {
                    return styles.colors.borderColor;
                  },
                  vLineColor() {
                    return styles.colors.borderColor;
                  },
                  vLineWidth() {
                    return 2;
                  },
                },
                alignment: "right",
                margin: [0, 10, 24, 0],
              },
            ],
            margin: [24, 12, 0, 0],
          },
          {
            canvas: [
              { type: "rect", x: 24, y: 90, w: pageSize.width - 48, h: 2 },
            ],
            margin: [0, 10],
          },
        ];
      },
      footer(currentPage, pageCount) {
        return {
          text: `Página ${currentPage} de ${pageCount}`,
          alignment: "right",
          fontSize: styles.fontSize.pdf.sm,
          color: styles.colors.colorDescription,
          margin: [0, 0, 24, 0],
        };
      },
      content: [
        {
          table: {
            headerRows: 0,
            widths: [95, "*", 90, "*"],
            body: [
              [
                {
                  text: "Proveedor:",
                  bold: true,
                  border: [true, true, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                  margin: [0, 5, 0, 0],
                },
                {
                  text: registers.proveedor_externo.razon_social,
                  border: [false, true, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                  margin: [0, 5, 0, 0],
                },
                {
                  text: "RNC emisor:",
                  bold: true,
                  border: [false, true, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                  margin: [0, 5, 0, 0],
                },
                {
                  text: registers.proveedor_externo.rnc || "---",
                  border: [false, true, true, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                  margin: [0, 5, 0, 0],
                },
              ],
              [
                {
                  text: "Receptor:",
                  bold: true,
                  border: [true, false, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: registers.receptor.razon_social || "---",
                  border: [false, false, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: "RNC receptor:",
                  bold: true,
                  border: [false, false, false, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: registers.receptor.rnc || "---",
                  border: [false, false, true, false],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
              ],
              [
                {
                  text: "Fecha emisión:",
                  bold: true,
                  border: [true, false, false, true],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: formatDateTime(
                    registers.orden.fecha_emision || registers.orden.created_at,
                  ),
                  border: [false, false, false, true],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: "Seguridad:",
                  bold: true,
                  border: [false, false, false, true],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: registers.orden.codigo_seguridad || "---",
                  border: [false, false, true, true],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
              ],
            ],
          },
          layout: "lightHorizontalLines",
        },
        {
          table: {
            headerRows: 1,
            widths: [35, 80, "*", 55, 55, 75, 70, 75],
            body: [
              [
                {
                  text: "#",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "Código",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "Descripción",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "U.M.",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "Cant.",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "P. Unit.",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "Imp.",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
                {
                  text: "Total",
                  bold: true,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorTitle,
                },
              ],
              ...registers.detalle.map((detail) => [
                {
                  text: detail.linea,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: detail.codigo_externo || "---",
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: detail.descripcion,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: detail.unidad_medida || "---",
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: detail.cantidad,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: `${money()}${format(detail.precio_unitario)}`,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: `${money()}${format(detail.impuesto)}`,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
                {
                  text: `${money()}${format(detail.total)}`,
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                  bold: true,
                },
              ]),
            ],
          },
          margin: [0, 15, 0, 0],
          layout: "lightHorizontalLines",
        },
        {
          table: {
            headerRows: 0,
            widths: [75, "*", 90],
            body: [
              [
                {
                  qr: qrValue,
                  fit: 65,
                  rowSpan: 4,
                  margin: [5, 10, 0, 0],
                  border: [true, true, false, true],
                  foreground: styles.colors.colorDescription,
                  background: styles.colors.white,
                },
                {
                  text: "Subtotal:",
                  bold: true,
                  alignment: "right",
                  border: [false, true, false, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
                {
                  text: `${money()}${format(registers.orden.subtotal)}`,
                  alignment: "right",
                  border: [false, true, true, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
              ],
              [
                {},
                {
                  text: "Impuesto:",
                  bold: true,
                  alignment: "right",
                  border: [false, false, false, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
                {
                  text: `${money()}${format(registers.orden.impuesto_total)}`,
                  alignment: "right",
                  border: [false, false, true, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
              ],
              [
                {},
                {
                  text: "Total:",
                  bold: true,
                  alignment: "right",
                  border: [false, false, false, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
                {
                  text: `${money()}${format(registers.orden.total)}`,
                  alignment: "right",
                  border: [false, false, true, false],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
              ],
              [
                {},
                {
                  text: "QR fiscal:",
                  bold: true,
                  alignment: "right",
                  border: [false, false, false, true],
                  fontSize: styles.fontSize.pdf.md,
                  color: styles.colors.colorTitle,
                },
                {
                  text: registers.orden.qr_url || registers.orden.ecf,
                  alignment: "right",
                  border: [false, false, true, true],
                  fontSize: styles.fontSize.pdf.sm,
                  color: styles.colors.colorDescription,
                },
              ],
            ],
          },
          margin: [0, 15, 0, 0],
        },
      ],
    };

    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    errorActions(error);
  }
};
